import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import './main.less';

const propTypes = {
	icon: PropTypes.string,
	notifications: PropTypes.number,
	triangle: PropTypes.bool,
	isActive: PropTypes.bool,
	children: PropTypes.any
};

class Item extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			opened: false
		};
	}
	render() {
		const {
			icon, notifications, triangle, children, isActive, hasNestedItems, nestedFromIndex, isHidden
		} = this.props;

		return (<li className={cn(
			'main-menu__menu-item',
			icon && `main-menu__menu-item--${icon}`,
			triangle && 'main-menu__menu-item--triangle',
			hasNestedItems && 'main-menu__menu-item--triangle-down',
			isActive && 'main-menu__menu-item--active',
			nestedFromIndex  && !isHidden && 'main-menu__nested-item',
			isHidden && 'display-none',
			this.state.opened && 'main-menu__menu-item--opened'
		)}
		onMouseOver={e => {
			const itemHasSubmenu = !!this.props.children[1];
			itemHasSubmenu && this.setState({opened: true});
		}}
		onMouseLeave={e => this.setState({opened: false})}
		onClick={e => {
			this.setState({opened: false});
		}}>
			{children}
			{notifications && <div className="main-menu__menu-notifications">{notifications}</div>}
		</li>);
	}
}

Item.propTypes = propTypes;

export default Item;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/components/menu/item/main.js